import { Component, inject, input, model, OnDestroy, OnInit } from '@angular/core';
import {Subscription} from 'rxjs';
import {Menu} from '../../types/left-menu.types';
import {Router} from '@angular/router';
import {SidebarService} from '../../../../services/sidebar.service';

@Component({
  selector: 'app-base-left-menu-item',
  standalone: true,
  imports: [],
  templateUrl: './base-left-menu-item.component.html',
  styleUrl: './base-left-menu-item.component.scss'
})
export class BaseLeftMenuItemComponent implements OnInit, OnDestroy {
  menu = input.required<Menu>();
  parentMenuId = input.required<string | null>();
  isMenuSmall = model<boolean>(false);

  protected router: Router = inject(Router);
  protected sidebarService: SidebarService = inject(SidebarService);

  protected subscriptions: Subscription = new Subscription();
  protected baseSubscriptions: Subscription = new Subscription();

  public ngOnInit(): void {
    this.initBaseSubscription();
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.baseSubscriptions.unsubscribe();
  }

  protected handleClick(): void {
    this.sidebarService.closeAllSubmenus();
    this.sidebarService.foldSidebar();
  }

  private initBaseSubscription(): void {
    this.baseSubscriptions.add(
      this.sidebarService.sidebarUnfolded$.subscribe({
        next: (isSidebarCollapsed: boolean) => this.isMenuSmall.set(isSidebarCollapsed)
      })
    );
  }
}
